export const reasons = {
  NO_MATCHED_PARTNER: '원하는 파트너를 찾지 못해서',
  NO_NEED_TO_SEARCH_PARTNER: '더 이상 제조 파트너 찾기에 대한 수요가 없어서',
  USELESS_ALARM: '불필요한 알람이 많이 와서',
  PERSONAL_INFORMATION_LEAKAGE: '개인정보 유출 불안',
  PRIVACY_ISSUE: '이직, 퇴사, 폐업 등 개인적인 사유',
  CONCERNED_ABOUT_QUALITY: '파트너 품질이 불안',
  ATEAM_SERVICE_PROBLEM: '에이팀벤처스 서비스 응대가 불만',
  ETC: '기타 사유'
};

export type ReasonType = keyof typeof reasons;

export const defaultValues: State = {
  reason: undefined,
  etcReason: undefined,
  check1: false,
  check2: false,
  check3: false,
  check4: false,
  check5: false
};

export interface State {
  reason?: ReasonType;
  etcReason?: string;
  check1?: boolean;
  check2?: boolean;
  check3?: boolean;
  check4?: boolean;
  check5?: boolean;
}
